import { TermsOfService } from "@/components/common/TermsOfService";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/en/cookies')({
  component: () => TermsOfService({ pdfPath: '/COOKIES_EN.pdf' }),
});